import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {of, ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../../shared/services/form-helper.service";
import {HttpErrorResponse} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {Support} from "../../../../shared/interface/support";
import {delay, takeUntil, tap} from "rxjs/operators";
import {Dictionary} from "../../../../shared/interface/dictionary";
import {SERVICE_TYPE_CORPORATION} from "../../../../shared/services/dict.service";
import {co} from "@fullcalendar/core/internal-common";

export interface PolicyOverrideDialogData {
  receivablesObject: ReceivablesImportRow;
  insuranceCompany: InsuranceCompany;
}

@Component({
  selector: 'app-policy-override-dialog',
  templateUrl: './policy-override-dialog.component.html',
  styleUrls: ['./policy-override-dialog.component.scss']
})
export class PolicyOverrideDialogComponent implements OnInit, OnDestroy   {

  policyOverrideForm: FormGroup;
  receivablesObject: ReceivablesImportRow;
  insuranceCompany: InsuranceCompany;
  processingRequest = false;
  receivablesBalanceControl: FormControl;
  registrationControl: FormControl;
  enableSaveButton = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<PolicyOverrideDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PolicyOverrideDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private receivablesImportsRowService: ReceivablesImportsRowService,
  ) {
    this.receivablesObject = data.receivablesObject;
    this.insuranceCompany = data.insuranceCompany;
    this.policyOverrideForm = fb.group({
      registration: this.registrationControl = fb.control('', [Validators.required ]),
      receivablesBalance: this.receivablesBalanceControl = fb.control('', [Validators.required ]),
    });
    this.initialize(this.receivablesObject);
  }

  ngOnInit(): void {
    this.policyOverrideForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.policyOverrideForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  sendForm(): void {
    this.processingRequest = true;

    this.receivablesImportsRowService.policyOverride(this.policyOverrideForm.value, this.receivablesObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zmieniono rejestracje', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu polisy wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }

  initialize(receivablesImportRow: ReceivablesImportRow): void {
    of(receivablesImportRow)
      .pipe(
        delay(0),
        tap(() => {
          this.policyOverrideForm.reset({
            registration: receivablesImportRow.registrationPartner?.registrationUuid,
            receivablesBalance: receivablesImportRow.receivablesBalance?.uuid
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }
}
